import { SUPER_SALES } from './../routes/routes';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { Dispatch, SetStateAction } from 'react';
import { MyOrderListModel } from '../views/Marketplace/Maeketplace.types';
import { OrderType } from '../views/Orders/Orders';
import {
  verifyPayTravelutionBundle,
  verifyPayTravelutionGoldenCard,
  verifyPayEventTickets,
  verifyPayTravelutionLicence,
  verifyPayTravelutionMembership,
  verifyPayTravelutionSubscription,
  verifySuperSales
} from '../views/Marketplace/Marketplace.actions';

export const getOrders = createAsyncThunk('auth/getInvoices', async () => {
  const { data } = await axios.get(`/package/my-package`);

  return data.data.orders as MyOrderListModel[];
});

export const cancelOrder = createAsyncThunk(
  'auth/cancelOrder',
  async ({
    userPackage,
    setIsCancelModalOpen
  }: {
    userPackage: any;
    setIsCancelModalOpen: Dispatch<SetStateAction<boolean>>;
  }) => {
    if (userPackage?.type === OrderType.PACKAGE) {
      await axios.put(
        `/products/travelution-memberships/my-orders/${userPackage.orderId}/cancel`
      );
    } else if (userPackage?.type === OrderType.TRAVEL_SUBSCRIPTION) {
      await axios.put(
        `/products/travelution-subscriptions/my-orders/${userPackage.orderId}/cancel`
      );
    } else if (userPackage?.type === OrderType.SUBCRIPTION_BUNDLE) {
      await axios.put(
        `/products/travelution-subscription-bundles/my-orders/${userPackage.orderId}/cancel`
      );
    } else if (userPackage?.type === OrderType.SUPER_SALES) {
      await axios.put(
        `/products/travelution-super-sales/my-orders/${userPackage.orderId}/cancel`
      );
    } else if (userPackage?.type === OrderType.ACCESS_PACKS) {
      await axios.put(
        `/products/travelution-access-packs/my-orders/${userPackage.orderId}/cancel`
      );
    } else {
      await axios.put(
        `/products/backoffice-licences/my-orders/${userPackage.orderId}/cancel`
      );
    }

    setIsCancelModalOpen(false);

    return userPackage.orderId;
  }
);

export enum OrderTypes {
  ORDER = 1,
  PACKAGE = 2,
  LICENCE = 3,
  COMBO = 4,
  TICKETS = 5
}

export interface accountingSliceType {
  loading: boolean;
  orders: MyOrderListModel[];
}

const initialState = {
  loading: false,
  orders: []
} as accountingSliceType;

const ordersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    removeOrdersState(state) {
      state = initialState;
    }
  },

  extraReducers: (builder) => {
    builder.addCase(getOrders.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getOrders.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.orders = payload;
    });
    builder.addCase(getOrders.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(cancelOrder.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(cancelOrder.fulfilled, (state, { payload }) => {
      state.loading = false;
      const index = state.orders.findIndex((p) => p.orderId === payload);
      state.orders[index].status = 4;
    });
    builder.addCase(cancelOrder.rejected, (state) => {
      state.loading = false;
    });

    //verify paying membership
    builder.addCase(verifyPayTravelutionMembership.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      verifyPayTravelutionMembership.fulfilled,
      (state, { payload }) => {
        state.loading = false;
        const index = state.orders.findIndex((p) => p.orderId === payload);
        state.orders[index].status = 2;
      }
    );
    builder.addCase(verifyPayTravelutionMembership.rejected, (state) => {
      state.loading = false;
    });

    //verify paying subscription
    builder.addCase(verifyPayTravelutionSubscription.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      verifyPayTravelutionSubscription.fulfilled,
      (state, { payload }) => {
        state.loading = false;
        const index = state.orders.findIndex((p) => p.orderId === payload);
        state.orders[index].status = 2;
      }
    );
    builder.addCase(verifyPayTravelutionSubscription.rejected, (state) => {
      state.loading = false;
    });

    //verify paying event tickets
    builder.addCase(verifyPayEventTickets.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(verifyPayEventTickets.fulfilled, (state, { payload }) => {
      state.loading = false;
      const index = state.orders.findIndex((p) => p.orderId === payload);
      state.orders[index].status = 2;
    });
    builder.addCase(verifyPayEventTickets.rejected, (state) => {
      state.loading = false;
    });

    //verify paying golden card
    builder.addCase(verifyPayTravelutionGoldenCard.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      verifyPayTravelutionGoldenCard.fulfilled,
      (state, { payload }) => {
        state.loading = false;
        const index = state.orders.findIndex((p) => p.orderId === payload);
        state.orders[index].status = 2;
      }
    );
    builder.addCase(verifyPayTravelutionGoldenCard.rejected, (state) => {
      state.loading = false;
    });

    //verify paying bundle
    builder.addCase(verifyPayTravelutionBundle.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      verifyPayTravelutionBundle.fulfilled,
      (state, { payload }) => {
        state.loading = false;
        const index = state.orders.findIndex((p) => p.orderId === payload);
        state.orders[index].status = 2;
      }
    );
    builder.addCase(verifyPayTravelutionBundle.rejected, (state) => {
      state.loading = false;
    });

    //verify paying super sales
    builder.addCase(verifySuperSales.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(verifySuperSales.fulfilled, (state, { payload }) => {
      state.loading = false;
      const index = state.orders.findIndex((p) => p.orderId === payload);
      state.orders[index].status = 2;
    });
    builder.addCase(verifySuperSales.rejected, (state) => {
      state.loading = false;
    });

    //verify paying license
    builder.addCase(verifyPayTravelutionLicence.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      verifyPayTravelutionLicence.fulfilled,
      (state, { payload }) => {
        state.loading = false;
        const index = state.orders.findIndex((p) => p.orderId === payload);
        state.orders[index].status = 2;
      }
    );
    builder.addCase(verifyPayTravelutionLicence.rejected, (state) => {
      state.loading = false;
    });
  }
});

export const { removeOrdersState } = ordersSlice.actions;

export default ordersSlice.reducer;
